module.exports = __webpack_public_path__ + "img/logo-white.909f6bff.png";